<app-ot-breadcrumbs state="otEvents" [city]="city"></app-ot-breadcrumbs>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">{{ 'otEvent_name' | l10n }}</th>
            <th scope="col">{{ 'otEvent_startDate' | l10n }}</th>
            <th scope="col">{{ 'otEvent_teacher' | l10n }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let otEventInfo of otEventInfoList; index as i">
            <td>
              <a [routerLink]="['/city/1/ot/event/' + otEventInfo.otEvent.id + '/registration/price']">{{ otEventInfo.otEvent.name }}</a>
              <div class="secondaryInfo">
                {{ otEventInfo.otEvent.room.venue.name }} -
                <span *ngIf="otEventInfo.otEvent.room.venue.street">{{ otEventInfo.otEvent.room.venue.street }}, </span>
                {{ otEventInfo.otEvent.room.venue.city.name }}
              </div>
            </td>
            <td>
              {{ otEventInfo.otEvent.startDate | localizedDate }}
              <div class="secondaryInfo">{{ otEventInfo.otEvent.startTime | time }} &ndash; {{ otEventInfo.otEvent.endTime | time }}</div>
            </td>
            <td>
              <div *ngIf="otEventInfo.otEvent.teacher.profilePictureName || otEventInfo.otEvent.teacher.profileText"><a (click)="showTeacherProfile(otEventInfo.otEvent.teacher)">{{ otEventInfo.otEvent.teacher.displayName }}</a>&nbsp;<span class="fa fa-user-o"></span></div>
              <div *ngIf="! otEventInfo.otEvent.teacher.profilePictureName && ! otEventInfo.otEvent.teacher.profileText">{{ otEventInfo.otEvent.teacher.displayName }}</div>
              <div class="secondaryInfo">{{ 'happening_occupancy' | l10n }}: {{ otEventInfo.registrationCount }} / {{ otEventInfo.capacity }}</div>
            </td>
            <td class="list-buttonCell"><button class="btn btn-secondary btn-sm" (click)="goToNextStep(otEventInfo)"><span class="fa fa-arrow-circle-right"></span>&nbsp;{{ 'button_select' | l10n }}</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
